import { Input } from 'antd';
import styled from '@emotion/styled';

export const RoundedInput = styled(Input)({
  borderRadius: 26,
  height: 52,
});
